import { IInstrument, IRealPrice } from '../types';
import { IPlaceOrderBody, TPlaceOrderType } from '@trader/api';

export const getTradingModelBE = (
  type: TPlaceOrderType,
  instrument: IInstrument,
  realPrice: IRealPrice
): IPlaceOrderBody => {
  const { general, market, limit } = instrument;

  const quantity = type === 'Market' ? market.amountVolume : limit.amount;
  const side = type === 'Market' ? market.billType : limit.billType;

  return {
    type:
      type === 'EntryLimit'
        ? limit.billType === 'Buy'
          ? 'EntryLimit'
          : 'EntryStop'
        : 'Market',
    symbol: general.symbol,
    quantity: Number(quantity),
    side,
    currentAsk: Number(realPrice.ask),
    currentBid: Number(realPrice.bid),
    price:
      type === 'EntryLimit'
        ? limit.billType === 'Buy'
          ? Number(limit.buyValue)
          : Number(limit.sellValue)
        : undefined,
    reportPriceChange: true,
    takeProfit: market.protection.isSwitchProfit
      ? {
          type: 'TakeProfit',
          limitPrice: Number(market.protection.profitValue),
        }
      : undefined,
    stopLoss: market.protection.isSwitchLoss
      ? {
          type: 'StopLoss',
          stopPrice: Number(market.protection.lossValue),
        }
      : undefined,
  };
};
